import { Helmet } from 'react-helmet';
import NotFound from '../Components/NotFound';



const Page404 = () => {
	return (
		<div id='contact_page'>
			<Helmet>
				<title>404 | Chess In Slums Africa </title>
				<meta
					name='description'
					content='Feel free to reach out to us for inquiries or partnerships. We are open to phone calls and messages. '
				/>
			</Helmet>
            <NotFound/>
		</div>
	);
};

export default Page404;
